import { useEffect } from 'react';
import { pushEvent } from '../events';
import { useRouter } from 'next/router';
import { EventTypes } from '../enums/event-types';

export const usePageView = () => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url: string) =>
      pushEvent(EventTypes.PAGE_VIEW, { url });
    router.events.on('routeChangeComplete', handleRouteChange);
    handleRouteChange(router.route);
    return () => router.events.off('routeChangeComplete', handleRouteChange);
  }, []);
};
